import React from "react";
import ESIPage from "@/components/esi-page/ESIPage";
import { capitalize } from "lodash";

function generateMetadata(params) {
  const title = params?.slug?.[0]?.split("-").map(capitalize).join(" ");
  return {
    title: title || "Home appliance installation services",
    description: `Customer services information at John Lewis & Partners`,
  };
}

function Page() {
  return <ESIPage />;
}

Page.generateMetadata = generateMetadata;

export default Page;
